import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useEffect } from "react";
import { action_fetch_order_list_all } from "../../../../../../../store/actions/pages/customer";
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../../../hooks/common";
import { useSelector } from "react-redux";
import OrderList from "../fragments/order-list";
import OrderListEmpty from '../fragments/list-empty/index';
import { useCallback } from "react";
import { useDispatch } from "react-redux";

const OrderListAll = props =>{
    useStyles(cls);
	const store = useStore();
	const params = useParams();
	const query = useQuery();
	const pageCustomer = useSelector(state=>state.pageCustomer);    
	const { orderListAll } = pageCustomer;
	const dispatch = useDispatch();

	useEffect(async () => {
		if (window.__INITIAL_STATE__) {
			  // Allow the passed state to be garbage-collected
			  delete window.__INITIAL_STATE__
		  } else {
			if(orderListAll?.data?.length <= 0){
				await OrderListAll.fetchData(store, params, query)
			}
		  }
	}, []);

	const loadHandle = useCallback(() =>{
		dispatch(action_fetch_order_list_all(false));
	}, []);

    return <div className={cls.OrderListAll}>
        <OrderList 
			request={loadHandle}
			orders={orderListAll?.data} 
			loading={orderListAll?.loading}
			finished={orderListAll?.skip!==0 && orderListAll?.finished}
		/>

		{
			orderListAll?.skip===0 && orderListAll?.finished && <OrderListEmpty />
		}
    </div>
}

OrderListAll.fetchData = async (store, params, search, headers) => {
	await store.dispatch(action_fetch_order_list_all(false, headers));
}

export default OrderListAll;